module.exports = __webpack_public_path__ + "assets/img/dsh.54c436f8.png";